module.exports = __webpack_public_path__ + "img/rank.ff59086b.png";